export interface MediaOutlet {
  name: string
  type: string
  url?: string
  emoji: string
}

export const mediaOutlets: MediaOutlet[] = [
  {
    name: 'La Prensa Honduras',
    type: 'Newspaper',
    url: 'https://www.laprensa.hn/',
    emoji: '📰',
  },
  {
    name: 'El Heraldo',
    type: 'Newspaper',
    url: 'https://www.elheraldo.hn/',
    emoji: '📰',
  },
  {
    name: 'La Tribuna',
    type: 'Newspaper',
    url: 'https://www.latribuna.hn/',
    emoji: '📰',
  },
  {
    name: 'Proceso Digital',
    type: 'Digital News',
    url: 'https://www.proceso.hn',
    emoji: '💻',
  },
  {
    name: 'Confidencial Honduras',
    type: 'Investigative',
    url: 'https://confidencialhn.com',
    emoji: '🔍',
  },
  {
    name: 'HRN Radio',
    type: 'Radio',
    url: 'https://www.radiohrn.hn',
    emoji: '📻',
  },
  {
    name: 'Televicentro',
    type: 'Television',
    url: 'https://www.televicentro.com/',
    emoji: '📺',
  },
  {
    name: 'Radio América',
    type: 'Radio',
    url: 'https://radioamerica.hn',
    emoji: '📻',
  },
  {
    name: 'El Pulso Honduras',
    type: 'Digital News',
    url: 'https://elpulso.hn',
    emoji: '💻',
  },
  {
    name: 'Criterio.hn',
    type: 'Digital News',
    url: 'https://criterio.hn',
    emoji: '💻',
  },
  {
    name: 'Tiempo Digital',
    type: 'Newspaper',
    url: 'https://www.tiempo.hn',
    emoji: '📰',
  },
]
